export enum FPS_BANKCODE {
  SCB_HK = 'SCB_HK',
  HSBC = 'HSBC',
  CCB_ASIA = 'CCB_ASIA',
  BOC_HK = 'BOC_HK',
  BEA = 'BEA',
  DBS_HK = 'DBS_HK',
  CMB_WING_LUNG = 'CMB_WING_LUNG',
  HANG_SENG = 'HANG_SENG',
  SHANGHAI_COM_BANK = 'SHANGHAI_COM_BANK',
  BOCOM_HK = 'BOCOM_HK',
  PUBLIC_BANK_HK = 'PUBLIC_BANK_HK',
  ICBC_ASIA = 'ICBC_ASIA',
  OCBC_WING_HANG = 'OCBC_WING_HANG',
  TAI_YAU_BANK = 'TAI_YAU_BANK',
  CHIYU_BANK = 'CHIYU_BANK',
  DAH_SING_BANK = 'DAH_SING_BANK',
  CHONG_HING_BANK = 'CHONG_HING_BANK',
  NCB = 'NCB',
  TAI_SANG_BANK = 'TAI_SANG_BANK',
  FUBON_BANK = 'FUBON_BANK',
  CITIBANK_HK = 'CITIBANK_HK',
  K_R_INTL = 'K_R_INTL',
  EPAYLINKS = 'EPAYLINKS',
  WECHAT_PAY_HK = 'WECHAT_PAY_HK',
  FINANCE_33 = '33_FINANCE',
  UNICARD = 'UNICARD',
  HKT_PAYMENT = 'HKT_PAYMENT',
  TNG_ASIA = 'TNG_ASIA',
  ALIPAY_HK = 'ALIPAY_HK',
  OCTOPUS = 'OCTOPUS',
  AUTOTOLL = 'AUTOTOLL',
  PAYME = 'PAYME',
}

export enum FPS_IDTYPE {
  FPSID = 'MERCHANT_ACCOUNT_IDENTIFIER_FPS',
  FPSMOBILE = 'MERCHANT_ACCOUNT_IDENTIFIER_MOBILE',
  FPSEMAIL = 'MERCHANT_ACCOUNT_IDENTIFIER_EMAIL',
}

export enum FPS_CURRENCY {
  HKD = 'HKD',
}
